var map = {
	"./aerospace-badge.png": "acb3",
	"./ag-badge.png": "eb6b",
	"./auto-badge.png": "6636",
	"./construct-badge.png": "9b8c",
	"./cosmetology-badge.png": "3a70",
	"./educate-badge.png": "f00c",
	"./energy-badge.png": "4b85",
	"./engineer-badge.png": "479e",
	"./engineering-badge.png": "b4ad",
	"./finance-badge.png": "072f",
	"./health-badge.png": "2a68",
	"./it-badge.png": "eb8c",
	"./law-badge.png": "9d05",
	"./manufacture-badge.png": "0a51",
	"./marketing-badge.png": "c7c2",
	"./persistance-badge.png": "8edd",
	"./safety-badge.png": "354c1",
	"./shipbuild-badge.png": "4dca",
	"./tourism-badge.png": "8473",
	"./transport-badge.png": "0721",
	"./undefined-badge.png": "5ba1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f6da";